<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DataTable from "@/components/DataTable.vue";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Agent Expenses",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Agent Expenses",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Agent Expenses",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsAgentExpensesServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount_field",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "mode_field",
          sortable: true,
          label: "MODE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "user",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE/TIME",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // delete category
      confirmdata: {
        amount: "",
        id: "",
        filterdata: {}
      },

      // delete category
      rejectdata: {
        amount: "",
        id: "",
        filterdata: {}
      },

      // Value from user input for adding category
      data: {
        description: "",
        category: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        amount: "",
        mode: "",
        filterdata: {}
      },
      // edit category
      editdata: {
        description: "",
        category: "",
        id: "",
        amount: "",
        mode: "",
        date: "",
      },
      // make inputs required
      amountError: "",
      dateError: "",
      categoryError: "",
      modeError: "",
      // delete category
      deletedata: {
        amount: "",
        id: "",
      },
      // filterAgentExpenses: {
      //   search: "",
      //   page: 1,
      //   per_page: 50,
      // },
      filterdata: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        category: "",
        page: 1,
        per_page: 50,
      },

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),

    ...mapGetters("expenses", ["AgentExpenses", "ExpenseSaveStatus", "ExpenseCategories", "SaveStatus","AgentExpensesPagination","AgentExpensesPaginated","AgentExpensesSummary"]),
    ...mapGetters("setting", ["PaymentOptions"]),
    ...mapGetters("auth", ["User"]),

    agentExpenseColumns() {
      return this.fields;
    },

    rows() {
      return this.IsAgentExpensesServerPaginated
        ? this.AgentExpensesPagination?.total
        : this.AgentExpensesPaginated
        ? this.AgentExpensesPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsAgentExpensesServerPaginated) {
          return (
            (this.AgentExpensesPagination && this.AgentExpensesPagination.per_page) ||
            this.filterdata.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsAgentExpensesServerPaginated) {
          this.filterdata.per_page = value;
          this.filterdata.page = 1;
          this.FetchExpenses(this.filterdata);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.AgentExpensesPaginated && this.AgentExpensesPagination
          ? this.AgentExpensesPagination.current_page
          : 1;
      },
      set(value) {
        if (this.AgentExpensesPaginated) {
          this.filterdata.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },
 
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  
  methods: {
    ...mapActions({
      AddExpenditure: "expenses/recordAgentExpense",
      FetchExpenses: "expenses/fetchAgentExpenses",
      RejectExpense: "expenses/rejectExpense",
      ConfirmExpense: "expenses/confirmExpense",
      FetchExpenseCategories: "expenses/fetchExpenseCategories",
      FetchModes: "setting/fetchPaymentOptions",
      EditExpenditure: "expenses/editAgentExpenses",
      DeleteExpense: "expenses/deleteAgentExpense",
    }),
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    
    setDefaultMode(){
      let defaultop = this.PaymentOptions.filter((mode)=>{
            return mode.default == 1;
        })
        this.data.mode = defaultop[0].id;
    },

    addExpense(modalId) {
      this.modal_id = modalId;

      if (this.data.amount === "") {
        this.amountError = "Amount Spent is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.data.category === "") {
        this.categoryError = "Expense Category is required";
        return;
      } else {
        this.categoryError = "";
      }
      if (this.data.date === "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }
      if (this.data.mode === "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }

      this.AddExpenditure(this.data);
    },

    resetAddExp() {
      this.data.date = "";
      this.data.amount = "";
      this.data.description = "";
      this.data.category = "";
      this.data.mode = "";
      this.amountError = "";
      this.dateError = "";
      this.modeError = "";
      this.categoryError = "";
      this.modal_id = "";
    },
    resetEditExp() {
      this.editdata.amount = "";
      this.editdata.date = "";
      this.editdata.mode = "";
      this.editdata.description = "";
      this.editdata.category = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDeleteExp() {
      this.deletedata.amount = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.amountError = "";
      this.dateError = "";
      this.modeError = "";
      this.categoryError = "";
    },
    showEditModal(row) {
      this.editdata.amount = row.amount;
      this.editdata.date = row.date;
      this.editdata.mode = row.mode.id;
      this.editdata.id = row.id;
      this.editdata.category = row.category.id;
      this.editdata.description = row.description;
    },
    editExpense(modalId) {
      this.modal_id = modalId;
      this.EditExpenditure(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.amount = data.item.amount;
      this.deletedata.id = data.item.id;
    },
    deleteExpenses(modalId) {
      this.modal_id = modalId;
      this.DeleteExpense(this.deletedata);
    },    

    resetRejectExp() {
      this.rejectdata.amount = "";
      this.rejectdata.id = "";
      this.modal_id = "";
    },
   
    showRejectModal(row) {
      this.rejectdata.amount = row.amount;
      this.rejectdata.id = row.id;
    },
    rejectExpenses(modalId) {
      this.modal_id = modalId;
      this.RejectExpense(this.rejectdata.id);
    },

    resetConfirmExp() {
      this.confirmdata.amount = "";
      this.confirmdata.id = "";
      this.modal_id = "";
    },
   
    showConfirmModal(row) {      
      this.confirmdata.amount = row.amount;
      this.confirmdata.id = row.id;
    },
    confirmExpenses(modalId) {
      this.modal_id = modalId;
      this.ConfirmExpense(this.confirmdata.id);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    filterReport() {
      const requiresServerPagination = this.filterdata.datefrom !== this.filterdata.dateto;

      let payload = { ...this.filterdata };

      if (requiresServerPagination) {
        payload.page = 1;
        payload.per_page = this.serverPerPage;
      } else {
        this.clientCurrentPage = 1;
      }

      this.FetchExpenses(payload);
    },

     handlePageChange(newPage) {
      if (this.IsAgentExpensesServerPaginated) {
        this.filterdata.page = newPage;
        this.FetchExpenses(this.filterdata);
      }
    },

    
  },

  created() {
    this.FetchExpenses(this.filterdata);
    this.filterReport();
    this.FetchExpenseCategories();
    this.FetchModes();
    setTimeout(()=> {
         this.setDefaultMode();
    }, 3000);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
            <div class="col-3">
                <div class="form-group">
                  <label>Expense Category</label>
                  <model-list-select
                      :list="ExpenseCategories ? [ { id: '', name: 'All Categories' }, ...ExpenseCategories ] : []"
                      v-model="filterdata.category"
                      option-value="id"
                      option-text="name"
                      class="mb-3"
                      placeholder="Select Category"
                      @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                      type="date"
                      v-model="filterdata.datefrom"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                      type="date"
                      v-model="filterdata.dateto"
                      class="form-control"
                      v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                      v-show="SaveStatus"
                      variant="light"
                      small
                      role="status"
                  ></b-spinner>
                </button>
              </div>
              <div class="col-3 mt-4">
                <b-button
                    v-if="User.is_agent == 1 && MyUserPerm.add_expenses == 1"
                    class="float-end"
                    variant="primary"
                    v-b-modal.add-expense-modal
                ><i class="fa fa-plus"></i> Record Expense</b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
              :columns="agentExpenseColumns"
              :rows="AgentExpensesPaginated"
              :total-rows="rows"
              :pagination="AgentExpensesPagination"
              :server-pagination="IsAgentExpensesServerPaginated"
              :loading="SaveStatus"
            >
              <!-- Index -->
              <template #cell(index)="data">
                {{ (currentPage - 1) * perPage + data.index + 1 }}
              </template>

              <template #cell(category.name)="data">
                {{ data.row && data.row.category ? data.row.category.name : "" }}
              </template>

              <template #cell(amount_field)="data">
                {{ thousandSeperator(data.row.amount) }}
              </template>

              <template #cell(mode_field)="data">
                {{ data.row.mode.name }} ({{ data.row.mode.type_name }} -
                {{ data.row.mode.account_number }})
              </template>
              <template #cell(description)="data">
                {{ data.row.description }}
              </template>

              <template #cell(user.names)="data">
                {{ data.row.user ? data.row.user.names : "" }}
              </template>

              <template #cell(date)="data">
                {{ data.row.date }}
              </template>

              <template #cell(actions)="data">
                <b-button-group>
                  <!-- Confirm -->
                  <b-button
                    v-if="User.is_agent == 'No' && User.role.edit_expenses == 1 && data.row.status == 1"
                    size="sm"
                    variant="success"
                    v-b-modal.confirm-expense-modal
                    @click="showConfirmModal(data.row)"
                  >
                    <i class="fa fa-check"></i> Confirm
                  </b-button>

                  <!-- Edit -->
                  <b-button
                    v-if="User.is_agent == 'Yes' && data.row.status == 1"
                    size="sm"
                    variant="info"
                    v-b-modal.edit-expense-modal
                    @click="showEditModal(data.row)"
                  >
                    <i class="fa fa-edit"></i> Edit
                  </b-button>

                  <!-- Reject -->
                  <b-button
                    v-if="User.is_agent == 'No' && User.role.delete_expenses == 1 && data.row.status == 1"
                    size="sm"
                    variant="warning"
                    v-b-modal.reject-expense-modal
                    @click="showRejectModal(data.row)"
                  >
                    <i class="fa fa-times"></i> Reject
                  </b-button>

                  <!-- Delete -->
                  <b-button
                    v-if="User.is_agent == 'Yes' && data.row.status != 2"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-expense-modal
                    @click="showDeleteModal(data)"
                  >
                    <i class="fa fa-trash"></i> Delete
                  </b-button>
                </b-button-group>

                <!-- Status labels -->
                <span v-if="data.row.status == 0" class="text-warning">Rejected</span>
                <span v-if="data.row.status == 2" class="text-success">Confirmed</span>
              </template>
            </DataTable>
            <div class="row" v-if="AgentExpensesSummary && AgentExpensesSummary.totalAmount > 0">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <h5>Total Agent Expenses: <span
                      class="text-danger">{{ AgentExpensesSummary.totalAmount.toLocaleString() }}</span>
                  </h5>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- add expense modal starts -->
            <b-modal id="add-expense-modal" hide-footer @hidden="resetAddExp">
              <template #modal-title> Record New Expense</template>
              <div class="form-group mb-3">
                <label>Expense Category</label>
                <model-list-select
                  :list="ExpenseCategories ? ExpenseCategories : []"
                  v-model="data.category"
                  option-value="id"
                  option-text="name"
                  class="mb-3"
                  placeholder="Select Expense Category"
                  @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="categoryError">
                  <em>{{ categoryError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Expense Amount</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.amount"
                    @input="resetErrors()"
                    placeholder="Amount Spent"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Date</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    v-model="data.date"
                    @input="resetErrors()"
                    v-limit-future-date
                  />
                </div>
                <div class="text-danger" v-if="dateError">
                  <em>{{ dateError }}</em>
                </div>
              </div>
              <div class="form-group">
                <label>Payment Method</label>
                <model-list-select
                  :list="PaymentOptions ? PaymentOptions : []"
                  v-model="data.mode"
                  option-value="id"
                  option-text="mode"
                  placeholder="Select Method"
                  @input="resetErrors()"
                >
                </model-list-select>
              </div>
              <div class="text-danger" v-if="modeError">
                <em>{{ modeError }}</em>
              </div>
              <div class="form-group mb-3">
                <label>Description</label>
                <div class="input-group">
                    <textarea rows="5" 
                    class="form-control"
                    v-model="data.description"
                    placeholder="Description"
                    >
                    </textarea>
                </div>
              </div>
              
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('add-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="addExpense('add-expense-modal')"
                >
                  <i class="fa fa-check"></i> Save Expense
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            <!-- edit modal starts -->
            <b-modal id="edit-expense-modal" hide-footer @hidden="resetEditExp">
              <template #modal-title> Edit Expense of {{ thousandSeperator(editdata.amount) }}</template>
              <div class="form-group mb-3">
                <label>Expense Category</label>
                <model-list-select
                  :list="ExpenseCategories ? ExpenseCategories : []"
                  v-model="editdata.category"
                  option-value="id"
                  option-text="name"
                  class="mb-3"
                  placeholder="Select Expense Category"
                >
                </model-list-select>
              </div>
              <div class="form-group mb-3">
                <label>Expense Amount</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="editdata.amount"
                    @input="resetErrors()"
                    placeholder="Amount Spent"
                  />
                </div>
                <div class="text-danger" v-if="amountError">
                  <em>{{ amountError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Date</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control"
                    v-model="editdata.date"
                    @input="resetErrors()"
                    v-limit-future-date
                  />
                </div>
                <div class="text-danger" v-if="dateError">
                  <em>{{ dateError }}</em>
                </div>
              </div>
              <div class="form-group">
                <label>Payment Method</label>
                <model-list-select
                  :list="PaymentOptions ? PaymentOptions : []"
                  v-model="editdata.mode"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Method"
                  @input="resetErrors()"
                >
                </model-list-select>
              </div>
              <div class="text-danger" v-if="modeError">
                <em>{{ modeError }}</em>
              </div>
              <div class="form-group mb-3">
                <label>Description</label>
                <div class="input-group">
                    <textarea rows="5" 
                    class="form-control"
                    v-model="editdata.description"
                    placeholder="Description"
                    >
                    </textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editExpense('edit-expense-modal')"
                >
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete expense starts -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-expense-modal"
              hide-footer
              @hidden="resetDeleteExp"
            >
              <template #modal-title> Delete Expenditure of {{ thousandSeperator(deletedata.amount) }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>Do you want to delete this expense? This is a permanent action.</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteExpenses('delete-expense-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete expense starts -->
            <b-modal
              header-bg-variant="warning"
              header-text-variant="light"
              body-text-variant="warning"
              footer-bg-variant="warning"
              footer-text-variant="warning"
              id="reject-expense-modal"
              hide-footer
              @hidden="resetRejectExp"
            >
              <template #modal-title> Reject Expenditure of {{ thousandSeperator(rejectdata.amount) }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>Do you want to reject this expense? This is a permanent action.</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('reject-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="rejectExpenses('reject-expense-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Rejecting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete expense starts -->
            <b-modal
              header-bg-variant="success"
              header-text-variant="light"
              body-text-variant="success"
              footer-bg-variant="success"
              footer-text-variant="success"
              id="confirm-expense-modal"
              hide-footer
              @hidden="resetConfirmExp"
            >
              <template #modal-title> Confirm Expenditure of {{ thousandSeperator(confirmdata.amount) }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>Do you want to confirm this expense? This is a permanent action.</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-success"
                  data-dismiss="modal"
                  @click="closeModal('confirm-expense-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="confirmExpenses('confirm-expense-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Confirming"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
